@use "@fukuri-admins/ui/layout" as *;

.sectionTitle {
  @include typography('Jp/16_W6');
  margin: 0;
  color: text('High');
}
